import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'position'
})
export class PositionPipe implements PipeTransform {

  transform(items: Array<any>, position: number): Array<any> {
    return items.filter(item => item.position == position);
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/position.pipe.ts